import NavSideBar from "../component/NavSideBar";

export default function Profile() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">Profile</div>
    </NavSideBar>
  )
}
